import {Component, Inject, OnInit} from '@angular/core';

import {
  AlertService,
  AuthenticationService,
  ComplianceAreaService,
  ControlItemsService,
  TenantService
} from '../../_services/index';

import {ComplianceArea, ControlItem} from '../../_models/index';

import {LoginHelper} from '../../helpers/index';

import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TenantPermissions} from "../../_models/tenantPermissions";

@Component({
    standalone: false,
  selector: 'control-item-component',
  templateUrl: 'edit.complianceArea.html',
  styleUrls: ['./edit.complianceArea.css'],
})

export class EditComplianceAreaComponent implements OnInit {
  loading = false;
  complianceArea: ComplianceArea;
  complianceAreaId: number;
  form: FormGroup;
  complianceAreas: ComplianceArea[];
  otherAreas: ComplianceArea[];
  selectedControlItems: ControlItem[];
  controlItems: ControlItem[];
  pairings: any[];
  pairingMap: any = {};
  tenantName: string;
  tenantPermissions: TenantPermissions = {};

  constructor(
    public dialogRef: MatDialogRef<EditComplianceAreaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public complianceAreaService: ComplianceAreaService,
    public controlItemsService: ControlItemsService,
    public tenantService: TenantService,
    public alertService: AlertService,
    public formBuilder: FormBuilder) {
  }

  ngOnInit() {

    this.tenantName = LoginHelper.getTenantName();
    if (this.tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    console.log(this.data.bulletin);

    this.complianceArea = Object.assign({}, this.data.complianceArea);
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      isExtended: [false],
      hasLevels: [false],
      securityAssessmentVisibility: [0],
      riskAssessmentVisibility: [0],
      isFedRamp: [false],
      maxScore: [0]
    });

    this.tenantService.getCurrent().subscribe(p => {
      this.tenantPermissions = p;
    });

    /*this.complianceAreaService.getComplianceAreas(this.tenantName).subscribe(a => {
      this.complianceAreas = a;
      this.otherAreas = a.filter(area => area.complianceAreaId != this.complianceArea.complianceAreaId);
    })

    this.controlItemsService.getAll(this.tenantName).subscribe(i => {
      this.selectedControlItems = i.filter(t => t.complianceAreaId == this.complianceArea.complianceAreaId);
      this.controlItems = i;
      //this.loadPairings();
    })*/
  }

  /*loadPairings() {
    this.controlItemsService.getComplianceAreaPairings(this.tenantName).subscribe(i => {
      this.pairings = i;

      this.pairingMap = {};
      this.pairings.forEach(p => {
        var from = this.controlItems.find(i => i.controlItemId == p.fromId);
        var to = this.controlItems.find(i => i.controlItemId == p.toId);
        this.pairingMap[from.controlItemId] = this.pairingMap[from.controlItemId] || {};
        this.pairingMap[from.controlItemId][to.complianceAreaId] = this.pairingMap[from.controlItemId][to.complianceAreaId] || [];
        this.pairingMap[from.controlItemId][to.complianceAreaId].push({
          pair: p,
          from: from,
          to: to
        });
      })
    })
  }*/

  onSave() {

    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach(field => { // {1}
        const control = this.form.get(field);            // {2}
        control.markAsTouched({onlySelf: true});       // {3}
      });
      return;
    }

    this.loading = true;

    this.alertService.clear();

    this.complianceArea.tenantName = LoginHelper.getTenantName();

    this.complianceAreaService.update(this.complianceArea)
      .subscribe(
        data => {
          this.alertService.success('The item data was updated.', true);
          this.loading = false;

          this.onClose();
        },
        error => {
          this.loading = false;
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  onClose(): void {
    this.dialogRef.close(this.complianceArea);
  }


  /*deletePair(id) {
    this.controlItemsService.deletePairing(id, this.tenantName).subscribe(() => {
      this.loadPairings();
    })
  }

  addPair(controlItemId, complianceAreaId) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        controlItems: this.controlItems.filter(i => i.complianceAreaId == complianceAreaId)
      }
    };


    var dialogRef = this.dialog.open(SelectControlItemComponent, config);
    //this.dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        var existing = this.pairings.find(p => p.toId == result.controlItemId);
        if (existing) {
          var fromItem = this.controlItems.find(i => i.controlItemId == existing.fromId);
          alert("This control is already mapped to receive updates from " + this.complianceAreas.find(a => a.complianceAreaId == fromItem.complianceAreaId).name + " Core Area");
          return;
        }

        this.controlItemsService.addPairing({
          fromId: controlItemId,
          toId: result.controlItemId
        }, this.tenantName).subscribe(() => {
          this.loadPairings();
        })
      }

    });
  }

  openControlItem() {

  }*/
}
